import React from "react";
import checkedImg from "../images/checked.png";

export default class BooleanInput extends React.Component {

    constructor(){
        super();

        this.state = {value: false};
    }


    componentDidMount(){
        this.setState({
            value: this.props.value
        });
    }

    render (){
        return ( 
        <div style={mainClass}>
            <div style={this.state.value? checked : unchecked} onClick={() => {
                let val = false;
                if (this.state.value)
                    val = false;
                else
                    val = true;
                this.setState({value: val});
                
                this.props.onChange(val);

                }}> </div>
            <div style={name}>{this.props.name}</div>
        </div>
        )
    }


}

const mainClass = {
    padding: '10px',
    display: 'flex'
}

const name = {
    'margin-left': '7px'
}

const checked = {
    width: '20px',
    height: '20px',
    border: '1px solid #666666',
    backgroundSize: '18px 18px',
    backgroundPosition: 'center',
    backgroundImage: `url(${checkedImg})`
}

const unchecked = {
    width: '20px',
    height: '20px',
    border: '1px solid #666666'
}